/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Onboarding_V1_Fund_All_Time_ReturnInputs */

const en_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`all time return ${i?.value}`)
};

const de_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gesamtrendite ${i?.value}`)
};

const pt_br2_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`retorno de todo o período ${i?.value}`)
};

const tr_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`tüm zamanların getirisi ${i?.value}`)
};

const zh_cn2_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`成立以来收益 ${i?.value}`)
};

const zh_hk2_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`歷來回報 ${i?.value}`)
};

const ko_kr2_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`전체 기간 수익률 ${i?.value}`)
};

const ru_ru2_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`доходность за всё время ${i?.value}`)
};

const es_419_onboarding_v1_fund_all_time_return = /** @type {(inputs: Onboarding_V1_Fund_All_Time_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`rendimiento histórico ${i?.value}`)
};

/**
* | output |
* | --- |
* | "all time return {value}" |
*
* @param {Onboarding_V1_Fund_All_Time_ReturnInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_all_time_return = /** @type {((inputs: Onboarding_V1_Fund_All_Time_ReturnInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_All_Time_ReturnInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "de") return de_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_all_time_return(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_all_time_return(inputs)
	return es_419_onboarding_v1_fund_all_time_return(inputs)
});